import React from 'react'
import Fade from '@mui/material/Fade'


const FadeTransition = React.forwardRef((props, ref) => (
  <Fade ref={ ref } { ...props } />
))


export default FadeTransition